import React from "react";

function OrderCategoryCard({ name, description, price, passengers, logo, isSelected, onSelect }) {
    return (
        <div className={`ride-option-card ${isSelected ? "selected" : ""}`} onClick={onSelect}>
            <div className="ride-option-image">
                <img src={logo} alt={name} />
            </div>
            <div className="ride-option-info">
                <div className="ride-option-header">
                    <div className={"ride-option-name-wrapper"}>
                        <span className="ride-option-name">{name}</span>
                        <span className="ride-option-passengers">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0ZM3 20c0-3.3 2.7-6 6-6h6c3.3 0 6 2.7 6 6v3H3v-3Z" fill="#999"></path></svg>{passengers}
                    </span>
                    </div>
                    <div className="ride-option-description">{description}</div>
                </div>
                <span className="ride-option-price">~{price.toFixed(2)} €</span>
            </div>
        </div>
    );
}

export default OrderCategoryCard;
